import axios from 'axios';
import { useDataAuth } from '../hooks/useDataAuth';

const BASE_URL = process.env.REACT_APP_AWS_API_GATEWAY_URL;

/**
 * Generic method for making API requests with Axios.
 * @param {string} url - API endpoint (concatenated with BASE_URL if necessary).
 * @param {string} method - Méthod HTTP ('GET', 'POST', 'PUT', 'DELETE', etc.).
 * @param {string} accessToken - Token de autentication (optional).
 * @param {Object} data - Body of request (for POST and PUT).
 * @param {Object} headers - Additional headers (opcional).
 * @param {Object} userSession - User session data (optional).
 * @returns {Promise} - Promise with API response.
 */


export const useApiRequest = () => {
    const [{ userSession }] = useDataAuth();
    return async ({
        url,
        method = 'GET',
        data = null,
        headers = {}
    }) => {
        try {
            const response = await axios({
                method,
                url: url !== '' ? url : `${BASE_URL}`,
                headers: {
                    'Content-Type': 'application/json',
                    ...(userSession && { Authorization: `Bearer ${userSession.token}` }), 
                    ...headers
                },
                data: data ? data : null 
            });
            return response.data;
        } catch (error) {
            console.error(`Error en la API (${method} ${url}):`, error);
            throw error;
        }
    };
};

